<div class="errorContent">
    <!-- <div class="shadowBox">
        <div class="errorInner text-center rd"><span class="iconBg"><span class="cgx-i cgx-i_LockedAccount"></span></span>
            <h1 class="pageTitle02">Thank you</h1>
            <h2 class="subTitle01-2">Your session has been logged out.</h2>
            <div class="formRow">
                <button (click)="login()"> <span>back to login</span></button>
            </div>
        </div>
    </div> -->
    <div class="shadowBox" *ngIf="errorCode == '404'">
        <div class="errorInner text-center rd"><span class="iconBg"><span class="cgx-i cgx-i_NoResultsFound"></span></span>
            <h1 class="pageTitle02">404</h1>
            <h2 class="subTitle01-2">Sorry, But this page doesn't exist.</h2>
            <div class="formRow" *ngIf="showLoginLink==true">
                <button (click)="navigateToHome()"> <span>back to homepage</span></button>
            </div>
        </div>
    </div>
    <div class="shadowBox" *ngIf="errorCode == '400'">
        <div class="errorInner text-center rd"><span class="iconBg"><span class="cgx-i cgx-i_Forbidden"></span></span>
            <h1 class="pageTitle02">400</h1>
            <h2 class="subTitle01-2">Bad Request</h2>
            <p>You've sent a bad request, Please log in again to continue</p>
            <div class="formRow" *ngIf="showLoginLink==true">
                <button (click)="login()"> <span>Login</span></button>
            </div>
        </div>
    </div>
    <div class="shadowBox" *ngIf="errorCode == '500'">
        <div class="errorInner text-center og"><span class="iconBg"><span class="cgx-i cgx-i_ConnectionProblem"></span></span>
            <h1 class="pageTitle02">500</h1>
            <h2 class="subTitle01-2">Internal Server Error</h2>
            <p>Please try again later</p>
            <div class="formRow" *ngIf="showLoginLink==true">
                <button (click)="navigateToHome()"> <span>back to homepage</span></button>
            </div>
        </div>
    </div>
    <div class="shadowBox" *ngIf="errorCode == '405'">
        <div class="errorInner text-center og"><span class="iconBg"><span class="cgx-i cgx-i_InternalServerError"></span></span>
            <h1 class="pageTitle02">405</h1>
            <h2 class="subTitle01-2">Method not allowed </h2>
            <p>The Request Method PUT is not allowed for the URL /.</p>
            <div class="formRow" *ngIf="showLoginLink==true">
                <button (click)="login()"> <span>login</span></button>
            </div>
        </div>
    </div>
    <!-- <div class="shadowBox">
        <div class="errorInner text-center blue"><span class="iconBg"><span class="errorImgInteral cgx-i cgx-i_PageNotFound"></span></span>
            <h2 class="subTitle01-2">Oops, Something went wrong</h2>
            <div class="formRow">
                <button> <span>back to homepage</span></button>
            </div>
        </div>
    </div> -->
    <div class="shadowBox" *ngIf="errorCode == '403'">
        <div class="errorInner text-center rd"><span class="iconBg"><span class="cgx-i cgx-i_Unauthorized"></span></span>
            <h1 class="pageTitle02">403</h1>
            <h2 class="subTitle01-2">Access Forbidden</h2>
            <p>The page you're trying to access has restricted access.</p>
            <div class="formRow" *ngIf="showLoginLink==true">
                <button (click)="login()"> <span>Login</span></button>
            </div>
        </div>
    </div>
    <!-- <div class="shadowBox">
        <div class="errorInner text-center og"><span class="iconBg"><span class="cgx-i cgx-i_RequestTimeout"></span></span>
            <h2 class="subTitle01-2">Your session is expired.</h2>
            <p>Please log in again to continue</p>
            <div class="formRow" *ngIf="showLoginLink==true">
                <button (click)="login()"> <span>login</span></button>
            </div>
        </div>
    </div> -->
    <div class="shadowBox" *ngIf="errorCode == '401'">
        <div class="errorInner text-center blue"><span class="iconBg"><span class="cgx-i cgx-i_VersionNotSupported"></span></span>
            <h1 class="pageTitle02">401</h1>
            <h2 class="subTitle01-2">Unauthorized</h2>
            <p>Please log in again to continue</p>
            <div class="formRow" *ngIf="showLoginLink==true">
                <button (click)="login()"> <span>login</span></button>
            </div>
        </div>
    </div>
    <div class="shadowBox" *ngIf="(errorCode == null || errorCode == undefined ) && errormsg != undefined && errormsg != null"> 
        <div class="errorInner text-center blue">
            <!-- <span class="iconBg"><span class="cgx-i cgx-i_VersionNotSupported"></span></span> -->
            <h1 class="pageTitle02">Error</h1>
            <h2 class="subTitle01-2">{{errormsg}}</h2>
            <!-- <p>{{errormsg}}</p> -->
            <div class="formRow" *ngIf="showLoginLink==true">
                <button (click)="login()"> <span>login</span></button>
            </div>
        </div>
    </div>
    
</div>